const pad2 = (value: number): string => String(value).padStart(2, "0");

const isValidDateParts = (year: number, month: number, day: number): boolean => {
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return false;
  if (month < 1 || month > 12 || day < 1 || day > 31) return false;
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

/** Normalizes common UI/API date strings to `YYYY-MM-DD`. */
export const formatDateToApiIso = (value: string | null | undefined): string => {
  const trimmed = typeof value === "string" ? value.trim() : "";
  if (!trimmed) return "";

  const datePart = trimmed.split(/\s+/)[0] ?? trimmed;

  const isoMatch = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const year = Number(isoMatch[1]);
    const month = Number(isoMatch[2]);
    const day = Number(isoMatch[3]);
    return isValidDateParts(year, month, day) ? `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}` : "";
  }

  const dottedMatch = datePart.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (dottedMatch) {
    const day = Number(dottedMatch[1]);
    const month = Number(dottedMatch[2]);
    const year = Number(dottedMatch[3]);
    if (!isValidDateParts(year, month, day)) return "";
    return `${year}-${pad2(month)}-${pad2(day)}`;
  }

  const slashMatch = datePart.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slashMatch) {
    const day = Number(slashMatch[1]);
    const month = Number(slashMatch[2]);
    const year = Number(slashMatch[3]);
    if (!isValidDateParts(year, month, day)) return "";
    return `${year}-${pad2(month)}-${pad2(day)}`;
  }

  return "";
};
